// extracted by mini-css-extract-plugin
export default {"container":"UN-z","modal":"VN-z","dimensions":"WN-z","brandName":"XN-z","productName":"YN-z","recipientEmail":"ZN-z","recommendedFit":"_N-z","hiddenField":"aO-z"};